import URI from "urijs";
import { createOktaAuth } from "@athena/identity-okta-auth-js";
import OktaAuth from "@okta/okta-auth-js";
import config from "./config";

function getIssuer(authServerId?: string): string {
  authServerId = authServerId || config.primaryAuthorizationServer.id;
  const { baseUrl } = config.primaryAuthorizationServer;
  const parsedUri = new URI(baseUrl);
  return parsedUri.segment(authServerId).toString();
}

export const getOktaAuthInstance = (authServerId?: string): OktaAuth => {
  const issuer = getIssuer(authServerId);
  return createOktaAuth({
    clientId: config.oauthClientId,
    redirectUri: config.redirectUri,
    scopes: config.scopes,
    issuer,
    pkce: true,
    ignoreLifetime: true,
    transactionManager: {
      enableSharedStorage: false,
    },
    cookies: {
      secure: true,
    },
    storageManager: {
      token: {
        storageType: "memory",
      },
    },
    ignoreSignature: true,
    useCustomHttpRequestClient: true,
  });
};
